import { useState, useCallback, ReactNode } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert, { AlertColor } from '@mui/material/Alert';
import { ToastContext } from '../context/toast-context';

type Position = {
  vertical: 'top' | 'bottom';
  horizontal: 'left' | 'center' | 'right';
};

export interface ToastOptions {
  message: string;
  severity?: AlertColor;
  duration?: number;
  position?: Position;
}

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const [opts, setOpts] = useState<ToastOptions | null>(null);


  const showToast = useCallback((options: ToastOptions) => {
    setOpts({
      severity: 'info',
      duration: 4000,
      position: { vertical: 'top', horizontal: 'right' },
      ...options,
    });
  }, []);

  const handleClose = (_?: unknown, reason?: string) => {
    if (reason === 'clickaway') return;
    setOpts(null);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      <Snackbar
        open={!!opts}
        autoHideDuration={opts?.duration}
        onClose={handleClose}
        anchorOrigin={opts?.position}
      >
        <Alert onClose={handleClose} severity={opts?.severity}>
          {opts?.message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
};